import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { Bar } from "react-chartjs-2";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
  zoomPlugin
);

export default function WordFrequencyChart({ data }) {
  const chartData = {
    labels: data.map(([word]) => word),
    datasets: [
      {
        label: "Frequency",
        data: data.map(([, count]) => count),
        backgroundColor: "#5C2D91",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          // Custom label: show word and count
          label: function (context) {
            // const word = context.label;
            const word = "Frequency";
            const count = context.raw;
            return `${word}: ${count}`;
          },
        },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
        precision: 0,
      },
    },
  };

  return <Bar data={chartData} options={chartOptions} />;
}
